// @ts-strict-ignore
import { faPencil } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";

import { Dropdown, DropdownButton, DropdownContent } from "@aviary";
import { DeleteCartModal } from "@emerson/components/MultiCartPopup/DeleteCartModal/DeleteCartModal";
import { MultiCartPopup } from "@emerson/components/MultiCartPopup/MultiCartPopup";
import { useEmersonCheckout } from "@shared/hooks/storePlatformCheckouts/useEmersonCheckout";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./MultiCart.styles";

const MultiCart = () => {
  const isEEv2Checkout = useEmersonCheckout();
  const { isAdminImpersonating } = useSharedGlobalConfig();
  const [cartToRemove, setCartToRemove] = useState<string>(null);

  if (!isAdminImpersonating || !isEEv2Checkout) return null;

  return (
    <>
      <Dropdown dropdownPlacement="bottom-end" isFullHeight css={styles.dropdown}>
        <DropdownButton data-testid="multi-cart-button">
          <FontAwesomeIcon icon={faPencil} size="1x" />
        </DropdownButton>
        <DropdownContent css={styles.content}>
          <MultiCartPopup setCartToRemove={setCartToRemove} />
        </DropdownContent>
      </Dropdown>
      <DeleteCartModal
        isOpen={!!cartToRemove}
        orderId={cartToRemove}
        onClose={() => setCartToRemove(null)}
      />
    </>
  );
};

export { MultiCart };
